import { CATEGORY_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminCategoryService = {
  getAll: (params: any) => requests.get(`${CATEGORY_URL}`, params),
  create: (params: any) => requests.post(`${CATEGORY_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${CATEGORY_URL}/${id}`),
  updatePosition: (params: any) => requests.patch(`${CATEGORY_URL}`, params),
  update: (params: any, id: number) =>
    requests.post(`${CATEGORY_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${CATEGORY_URL}/${id}`),
};
